import {privateApi} from 'utils/api'
import {type ITxnErrorsReqPayload, type IFetchCountParams} from 'features/AC-OpsDashboard/ac-opsdash.types'

export const getMyBranchRequest = async (payload: any) =>
    await privateApi.post('/cps/v1/airline-dashboard/branchrequest-count', payload)

export const getTxnErrors = async (payload: ITxnErrorsReqPayload) =>
    await privateApi.post('/cps/v1/airline-dashboard/transaction-error-count', payload)

export const getInquiriescount = async (payload: any) =>
    await privateApi.post('/cps/v1/airline-dashboard/customer-inquiry-count', payload)

export const getInquiriesBlob = async (payload: IFetchCountParams) =>
    await privateApi.post('/cps/v1/airline-dashboard/customer-inquiry-export', payload, {
        responseType: 'blob'
    })
